export default __webpack_public_path__ + "static/media/Justine Maombi.b44e5a9b.JPG";